import { HttpClientModule, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, Injectable, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import './_interfaces/constraint.interface';

import { ApiService, ConstraintService, GlobalService, NavigationService } from './_services';


//import '../_interfaces/constraint.interface';
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log(`HttpRequestInterceptor.intercept(${req.url})`);

        if (req.url.indexOf('soa') == -1) {
            req = req.clone({
                withCredentials: environment.switches.withCredentials
            });
        }
        return next.handle(req);
    }
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
        HttpClientModule,
        HttpClientModule,
        RouterModule.forRoot([
            { path: "", redirectTo: "retbenefit", pathMatch: "full" },
            {
                path: "retbenefit",
                loadChildren: "./retbenefit/app.module#RetBenefit_Module"
            }
        ])
    ],
    providers: [
        ApiService,
        GlobalService,
        NavigationService,
        [
            { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true }
        ],
        {
            provide: APP_INITIALIZER,
            useFactory: (globalService: GlobalService) => () => {
                globalService.isLoadingApp = true;
            },
            multi: true,
            deps: [GlobalService]
        },
        ConstraintService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private globalService: GlobalService) { }
}
